<template lang="pug">
  v-container(fluid).exams-page
    portal(to='toolbar') 
      v-toolbar-title Exams
    v-row
      v-col(cols=6 v-show="!isPreviewAtSide('left')")
        exams(
          ref="exams"
        )
      v-col(cols=6 v-show="isPreviewAtSide('left')")
        question-item-preview(
          :itemModel="previewItemModel"
          title="Preview"
        )
      v-col(cols=6 v-show="!isPreviewAtSide('right')")
        questions(
          ref="questions"
          v-show="!isQuestionCreatingVissible"
          @onItemDelete="onQuestionDelete"
        )
        question-item(
          v-show="isQuestionCreatingVissible"
          :layout="preselectLayout"
          :isVisible="isQuestionCreatingVissible"
          :itemModel="editItemModel"
          :editMode="editMode"
          @questionCreated="onQuestionCreate"
          @questionUpdated="onQuestionUpdate"
          @onItemClose="onQuestionClose"
          title="Add Question"
        )
      v-col(cols=6 v-if="isPreviewAtSide('right')")
        question-item-preview(
          :itemModel="previewItemModel"
          title="Preview"
        )
</template>

<script>

export default {
  data: () => ({
    isQuestionCreatingVissible: false,
    isQuestionPreviewVissible: false,
    previewItemModel: null,
    previewPosition: null,
    editMode: false,
    editItemModel: null,
    preselectLayout: null,
  }),
  methods: {
    isPreviewAtSide(side) {
      return this.isQuestionPreviewVissible && this.previewPosition === side;
    },
    onQuestionCreate() {
      this.$refs.questions.loadData();
    },
    async onQuestionUpdate(updatedQuestion) {
      try {
        const actualPage = await this.$refs.questions.getQuestionPage(updatedQuestion.id);
        const pageToReload = !actualPage ? 1 : actualPage < updatedQuestion.page ? actualPage : updatedQuestion.page;
        await this.$refs.questions.mergeUpdatedQuestionPage(pageToReload ? pageToReload : actualPage);
        this.$refs.exams.loadData();
      } catch(e) {
      }
    },
    onQuestionDelete() {
      this.$refs.exams.loadData();
    },
    toggleQuestionPreview(position = 'right', item = {}, isVisible = false) {
      this.isQuestionPreviewVissible = isVisible;
      this.previewPosition = position;
      this.previewItemModel = item;
    },
    showQuestionEdit(item = {}) {
      this.isQuestionCreatingVissible = true;
      this.editItemModel = item;
      this.editMode = true;
      if (this.previewItemModel) {
        this.previewItemModel = null;
        this.isQuestionPreviewVissible = false;
      }
    },
    onQuestionClose() {
      this.isQuestionCreatingVissible = false;
      this.editItemModel = null;
      this.editMode = false;
    },
    toggleQuestionCreate(isVisible, layout) {
      const layoutQuery = Array.isArray(layout) ? layout[0] : layout
      this.preselectLayout = layoutQuery;
      this.isQuestionCreatingVissible = isVisible;
    },
  },
  components: {
    exams: () => import("./components/Exams.vue"),
    questions: () => import("@/app/exercise/modules/trainings/components/TrainingsQuestions.vue"),
    questionItem: () => import("@/app/exercise/components/question/QuestionItem.vue"),
    questionItemPreview: () => import("@/app/exercise/components/question/QuestionItemPreview.vue"),
  },
  provide: function() {
    return {
      toggleQuestionPreview: this.toggleQuestionPreview,
      toggleQuestionCreate: this.toggleQuestionCreate,
      showItemEdit: this.showQuestionEdit,
    }
  },
};
</script>
<style lang="scss" scoped>
.exams-page::v-deep {
  .v-card {
    .card-header {
      height: 64px;
    }
    .body {
      height: 100vh;
      max-height: calc(100vh - 236px);
      overflow: auto;
      &.inner-scroll {
        overflow: auto;
        display: flex;
        flex-direction: column;
      }
      &.no-footer {
        max-height: calc(100vh - 177px);
      }
    }
  }
}
</style>
